module.exports = __webpack_public_path__ + "media/bootstrap-icons/pin-map-1bdce50a.svg";